import { render, staticRenderFns } from "./caseClassify.vue?vue&type=template&id=24788da3&scoped=true&"
import script from "./caseClassify.vue?vue&type=script&lang=js&"
export * from "./caseClassify.vue?vue&type=script&lang=js&"
import style0 from "./caseClassify.vue?vue&type=style&index=0&id=24788da3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24788da3",
  null
  
)

export default component.exports